module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--bg-d4b3544ca53893714dff1b62e7811277.jpg";